import React, { Component } from 'react';
import { FormattedMessage } from "react-intl";
import Icon from "../common/icon/icon.component.jsx";
import { PAYMENT_STATUS } from "../state/helpers/Payment";

class PaymentStatus extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            status: this.props.value || '',
            className: this.props.className || '',
        }
    }


    componentWillReceiveProps(nextProps) {
        this.setState({
            status: nextProps.value || '',
            className: nextProps.className || '',
        })
    }

    componentDidMount() { }



    render() {
        if (!this.state.status) {
            return ''
        }

        const details = {
            [PAYMENT_STATUS.PENDING]: {
                icon: 'hourglass-half',
                label: <FormattedMessage
                    id="payment.status.pending"
                    defaultMessage="Pending"
                />,
                className: 'badge-warning'
            },
            [PAYMENT_STATUS.CAPTURED]: {
                icon: 'check',
                label: <FormattedMessage
                    id="payment.status.captured"
                    defaultMessage="Captured"
                />,
                className: 'badge-success'
            },
            [PAYMENT_STATUS.PAID]: {
                icon: 'check',
                label: <FormattedMessage
                    id="payment.status.paid"
                    defaultMessage="Paid"
                />,
                className: 'badge-success'
            },
            [PAYMENT_STATUS.DECLINED]: {
                icon: 'times',
                label: <FormattedMessage
                    id="payment.status.declined"
                    defaultMessage="Declined"
                />,
                className: 'badge-danger'
            },
            [PAYMENT_STATUS.EXPIRED]: {
                icon: 'times',
                label: <FormattedMessage
                    id="payment.status.expired"
                    defaultMessage="Expired"
                />,
                className: 'badge-danger'
            },
            [PAYMENT_STATUS.VOIDED]: {
                icon: 'times-circle',
                label: <FormattedMessage
                    id="payment.status.voided"
                    defaultMessage="Voided"
                />,
                className: 'badge-danger'
            },
            [PAYMENT_STATUS.SYNC_REQUESTED]: {
                icon: 'hourglass-half',
                label: <FormattedMessage
                    id="payment.status.sync_requested"
                    defaultMessage="Sync requested"
                />,
                className: 'badge-warning'
            },
            [PAYMENT_STATUS.REFUNDED]: {
                icon: 'undo',
                label: <FormattedMessage
                    id="payment.status.refunded"
                    defaultMessage="Refunded"
                />,
                className: 'badge-warning'
            },
            [PAYMENT_STATUS.PARTIALLY_REFUNDED]: {
                icon: 'undo',
                label: <FormattedMessage
                    id="payment.status.partially_refunded"
                    defaultMessage="Partially refunded"
                />,
                className: 'badge-warning'
            },
            [PAYMENT_STATUS.TRANSFERRED]: {
                icon: 'share',
                label: <FormattedMessage
                    id="payment.status.transferred"
                    defaultMessage="Transferred"
                />,
                className: 'badge-warning'
            },
            [PAYMENT_STATUS.CANCELED]: {
                icon: 'times',
                label: <FormattedMessage
                    id="payment.status.canceled"
                    defaultMessage="Canceled"
                />,
                className: 'badge-secondary'
            }
        }

        return <span className={this.state.className + " badge badge-pill " + details[this.state.status].className}>
            <Icon className={'mr-1'} value={details[this.state.status].icon} />
            {details[this.state.status].label}
        </span>
    }

}

export default PaymentStatus





// WEBPACK FOOTER //
// ./src/payment/status.component.jsx